module.exports = "/images/PresentationChart.svg";